import React from 'react';

import { createClassName } from 'utils/createClassName';

import './dashboardPageLayoutStyles.scss';

type Props = {
  primaryStat: React.ReactNode;
  secondaryStat: React.ReactNode;
  content: React.ReactNode;
  description?: React.ReactNode;
};

export const DashboardPageLayoutComponent = (props: Props) => {
  const { primaryStat, secondaryStat, content, description } = props;

  const createDashboardPageLayoutClassName = createClassName(
    'dashboardPageLayout'
  );

  const wrapperClassName = createDashboardPageLayoutClassName('wrapper');

  const statClassName = createDashboardPageLayoutClassName('stat');

  const primaryStatClassName = createDashboardPageLayoutClassName(
    'primaryStat'
  );

  const secondaryStatClassName = createDashboardPageLayoutClassName(
    'secondaryStat'
  );

  const contentClassName = createDashboardPageLayoutClassName('content');

  const descriptionClassName = createDashboardPageLayoutClassName(
    'description'
  );

  return (
    <div className={wrapperClassName}>
      {(!!primaryStat || !!secondaryStat) && (
        <div className={statClassName}>
          <div className={primaryStatClassName}>{primaryStat}</div>
          <div className={secondaryStatClassName}>{secondaryStat}</div>
        </div>
      )}
      {description && <div className={descriptionClassName}>{description}</div>}
      <div className={contentClassName}>{content}</div>
    </div>
  );
};
